<template>
    <div class="about">
        <v-header />
        <v-sidebar />
        <div class="content-box" >
            <div class="content">
                <div>
                    <div class="crumbs">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item>
                                <i class="el-icon-paperclip"></i> {{query.selectType=='trash'?'回收站':'帖子管理'}}(共 {{pageTotal}} 条）
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="container">
                        <div class="handle-box">
                            <el-input v-model="query.ftitle" placeholder="标题" class="handle-input mr10"></el-input>
                            <el-select v-model="query.typeId" placeholder="请选择" filterable>
                                <el-option label="请选择板块" ></el-option>
                                <el-option
                                        v-for="item in typelist"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <el-input v-model="query.unameLike" placeholder="用户名" class="handle-input mr10"></el-input>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                            <el-button type="danger" v-if="query.selectType==''&&lander.role=='100'"  @click="handleTrash">回收站 {{trashNum}}</el-button>
                            <el-button type="success" v-if="query.selectType=='trash'&&lander.role=='100'"  @click="handleManage">帖子管理</el-button>
                        </div>
                        <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header" size="mini">
                            <el-table-column prop="id" label="ID" width="100" align="center" fixed="left"></el-table-column>
                            <el-table-column  label="标题"  align="center"  fixed="left" width="200">
                                <template #default="scope">
                                    <router-link :to="'ForumDetail?id='+scope.row.id+'&goPosition=top'" target="_blank">{{scope.row.ftitle}}</router-link>
                                    <el-tag v-if="scope.row.manageShow=='0'||scope.row.authorShow=='0'" type="danger">已在回收站</el-tag>
                                    <span v-else>
                                        <el-tooltip v-if="scope.row.isbest=='1'" class="item" effect="dark" :content="scope.row.bestStart+'到'+scope.row.bestEnd" placement="top-start">
                                        <el-tag type="success" >收录</el-tag>
                                        </el-tooltip>
                                        <el-tooltip  v-if="scope.row.isbest=='0'&&scope.row.bestStart!='0'" class="item" effect="dark" :content="scope.row.bestStart+'到'+scope.row.bestEnd" placement="top-start">
                                         <el-tag >将收录</el-tag>
                                        </el-tooltip>
                                        <el-tooltip  v-if="scope.row.istop=='1'" class="item" effect="dark" :content="scope.row.topStart+'到'+scope.row.topEnd" placement="top-start">
                                        <el-tag  type="success">置顶</el-tag>
                                        </el-tooltip>
                                        <el-tooltip v-if="scope.row.istop=='0'&&scope.row.topStart!='0'" class="item" effect="dark" :content="scope.row.topStart+'到'+scope.row.topEnd" placement="top-start">
                                        <el-tag >将置顶</el-tag>
                                        </el-tooltip>
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column label="状态"  align="center" width="200">
                                <template #default="scope">
                                    <p v-if="scope.row.manageShow=='0'"  style="font-size: 12px;background: #f4f4f4;">管理员删除
                                        <span v-if="scope.row.delMsg!=null&&scope.row.delMsg.length>0"> <br>原因：{{scope.row.delMsg}}</span>
                                        <span v-if="scope.row.delTs!=null&&scope.row.delTs.length>0"> <br>时间：{{scope.row.delTs}}</span>

                                    </p>

                                    <p v-if="scope.row.authorShow=='0'"  style="font-size: 12px;">作者删除</p>
                                    <el-tag v-if="scope.row.manageShow=='1'&&scope.row.authorShow=='1'">正常显示</el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column prop="name" label="板块名称" width="120"  align="center">
                                <template #default="scope">
                                    <router-link :to="'Forum?typeId='+scope.row.typeId" target="_blank">{{scope.row.name}}</router-link>
                                </template>
                            </el-table-column>
                            <el-table-column prop="uname" label="作者"  align="center">
                                <template #default="scope">
                                    <router-link :to="'Home?type=myforum&authorId='+scope.row.authorUid" target="_blank">{{scope.row.uname}}</router-link>
                                </template>
                            </el-table-column>
                            <el-table-column prop="commentNum" label="评论量"  align="center"></el-table-column>
                            <el-table-column prop="hitNum" label="点赞量"  align="center"></el-table-column>
                            <el-table-column prop="viewNum" label="浏览量"  align="center"></el-table-column>
                            <el-table-column prop="collectNum" label="收藏量"  align="center"></el-table-column>
                            <el-table-column prop="commentNum" label="评论量"  align="center"></el-table-column>
                            <el-table-column prop="cts" label="创建时间" width="180" align="center"></el-table-column>
                            <el-table-column prop="editTs" label="最后编辑"  width="180" align="center"></el-table-column>



                            <el-table-column label="操作" width="120" align="center" fixed="right">
                                <template #default="scope">


                                    <el-dropdown>
                                        <el-button type="primary">
                                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item  v-if="scope.row.manageShow=='1'&&scope.row.authorShow=='1'">
                                                <el-button type="text" icon="el-icon-top"
                                                           @click="handleTopbest(scope.$index, scope.row,'top')">置顶
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item v-if="scope.row.topStart!='0'&&scope.row.manageShow=='1'&&scope.row.authorShow=='1'">
                                                <el-button type="text" icon="el-icon-close"
                                                           @click="handleCancelTopbest(scope.$index, scope.row,'top')">取消置顶
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item  v-if="scope.row.manageShow=='1'&&scope.row.authorShow=='1'">
                                                <el-button type="text" icon="el-icon-magic-stick"
                                                           @click="handleTopbest(scope.$index, scope.row,'best')">收录
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item v-if="scope.row.bestStart!='0'&&scope.row.manageShow=='1'&&scope.row.authorShow=='1'">
                                                <el-button type="text" icon="el-icon-close"
                                                           @click="handleCancelTopbest(scope.$index, scope.row,'best')">取消收录
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item  v-if="scope.row.manageShow=='1'&&scope.row.authorShow=='1'&&lander.role=='100'||lander.role=='50'">
                                                <el-button type="text" icon="el-icon-price-tag"
                                                           @click="handleMove(scope.$index, scope.row)">移动
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item  v-if="scope.row.manageShow=='1'&&scope.row.authorShow=='1' ">
                                                <el-button type="text" icon="el-icon-delete" class="red"
                                                           @click="handleDelete(scope.$index, scope.row)">删除
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item  v-if="(scope.row.manageShow=='0'||scope.row.authorShow=='0')&&lander.role=='100'">
                                                <el-button type="text" icon="el-icon-check"
                                                           @click="handleShow(scope.$index, scope.row)">恢复
                                                </el-button>
                                            </el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="handlePageChange"
                                    :current-page="query.pageNo"
                                    :page-sizes="[10,20,30]"
                                    :page-size="query.pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="pageTotal">
                            </el-pagination>
                        </div>
                    </div>


                </div>
            </div>
        </div>

     <!-- // :rules="topbestDataRule" -->

        <!--置顶,收录 -->
        <el-dialog :title="(topbestData.type=='top'?'设置置顶':'设置收录')+'-'+ topbestData.ftitle " :visible.sync="topbestVisible">
            <el-form
                    label-width="120px"
                    :model="topbestData"
                    
                    ref="topbestData"
            >
                <el-form-item label="开始时间" prop="start">
                    <el-date-picker
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="topbestData.start"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="end">
                    <el-date-picker
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="topbestData.end"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>

            <template #footer>


                    <span class="dialog-footer">
                        <el-button @click="topbestVisible = false">取 消</el-button>
                        <el-button type="primary" @click="saveTopbestHnadle">确 定</el-button>
                    </span>
            </template>
        </el-dialog>

        <!--删除 -->
        <el-dialog :title=" ' 删除-'+ delData.ftitle " :visible.sync="delVisible">
                <p>请输入删除的原因</p>
                 <el-input  v-model="delData.delMsg" type="textarea"/>
                 <p>  <el-tag v-for="(t,i) in delMsgli" @click="delData.delMsg=t" :key="i">{{t}}</el-tag></p>

            <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="delVisible = false">取 消</el-button>
                        <el-button type="primary" @click="suredel">确定删除</el-button>
                    </span>
            </template>
        </el-dialog>

        <!--移动 -->
        <el-dialog :title=" ' 移动-'+ moveData.ftitle " :visible.sync="moveVisible">
            <div>移动到
                <el-select v-model="moveData.typeId" placeholder="请选择"  >

                    <el-option
                            v-for="item in typelist"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>

            <template #footer>
                    <span class="dialog-footer">
                        <el-button size="small" @click="moveVisible = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="suremove">确定移动</el-button>
                    </span>
            </template>
        </el-dialog>

    </div>
</template>

<script>
    import vHeader from "./Header.vue";
    import vSidebar from "./Sidebar.vue";
    import {
        admin_forum_page,
        admin_forum_del,
        getTypeForumList,
        admin_forum_getTrashNum,
        admin_forum_saveTopBest,
        admin_forum_showNormal,
        admin_forum_move,
        admin_users_type_seeTypes,
        admin_type_getlist
    } from '../../api';
    import {dealResult} from "../../api/common";
    export default {
        name: "AdminForum",
        components: {
            vHeader,
            vSidebar,
        },
        data() {
            const confirmEndDate = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === ""|| str === "0") {
                    callback("请输入结束时间");
                }   else if (str < this.topbestData.start) {
                    callback('结束时间错误!');
                } else {
                    callback();
                }
            };
            return {
                delMsgli:["广告","心术不正","言辞不雅"],
                delVisible:false,
                delData: {},

                moveVisible:false,
                moveData: {
                    id:'',
                    typeId:'',
                    ftitle:'',
                },


                lander:{},
                trashNum:0,
                typelist:[],
                tableData: [],
                query :{
                    unameLike: '',
                    ftitle: '',
                    typeId: '',
                    pageNo: 1,
                    pageSize: 10,
                    selectType:'',
                },
                pageTotal: 0,


                topbestVisible: false,
                topbestData :{
                    id :'',
                    start : '',
                    end : '',
                },
                topbestDataRule: {
                    start: [{required: true, message: '不能为空', trigger: 'blur'}],
                    end: [{required: true, message: '不能为空', trigger: 'blur'},
                    {validator: confirmEndDate, trigger: ["change", "blur"]}],
                },
            };
        },
        methods:{
            //移动操作
            handleMove(index,row){
                this.moveVisible=true;
                this.moveData.id =row.id;
                this.moveData.ftitle =row.ftitle;
                this.moveData.typeId =row.typeId;
            }, 

            suremove(){
                if(this.moveData.typeId==''){
                    this.$message.error('请选择板块');return;
                }
                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                    id:this.moveData.id,
                    typeId:this.moveData.typeId
                }
                admin_forum_move(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.moveVisible=false;
                        this.$message.success(res.data.msg);
                        this.getPage();
                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },

            handleCancelTopbest(index,row,type){
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:type,
                    start:'0',
                    end:'0',
                    id:row.id,
                }

                // 二次确认
                this.$confirm("确定取消【"+row.ftitle+"】的"+(type=='top'?'置顶？':'收录？'), "提示", {
                    type: "warning",
                }) .then(() => {
                        this.saveTopBest(o);

                });



            },
            handleTopbest(index,row,type){
                this.topbestVisible=true;
                this.topbestData.ftitle=row.ftitle;
                this.topbestData.id=row.id;
                this.topbestData.end='';
                this.topbestData.start='';
                this.topbestData.type=type;

                if(type=='top'){
                    if(row.topStart!='0')this.topbestData.start=row.topStart;
                    if(row.topEnd!='0')this.topbestData.end=row.topEnd;
                }
                if(type=='best'){
                    if(row.bestStart!='0')this.topbestData.start=row.bestStart;
                    if(row.bestEnd!='0')this.topbestData.end=row.bestEnd;
                }
            },
            //保存操作
            saveTopbestHnadle(){
                var startTime;
                var endTime;
                if(this.topbestData.start == ""||this.topbestData.end == ""){
                    startTime = 1,
                    endTime = 1
                }else{
                    startTime = this.topbestData.start,
                    endTime = this.topbestData.end
                }
                        let o={  uid:this.lander.uid,
                            token:this.lander.token,
                            type:this.topbestData.type,
                            start:startTime,
                            end:endTime,
                            id:this.topbestData.id,
                        }
                        this.saveTopBest(o);
            },
            saveTopBest(o){
                admin_forum_saveTopBest(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.$message.success(res.data.msg)
                        this.topbestVisible = false;
                        this.getPage();
                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },
            handleManage(){
                this.tableData=[];
                this.query.selectType='';
                this.query.unameLike='';
                this.query.typeId='';
                this.query.pageNo = 1;
                this.getPage();
            },
            handleTrash(){
                this.tableData=[];
                this.query.selectType='trash';
                this.query.unameLike='';
                this.query.typeId='';
                this.query.pageNo = 1;
                this.getPage();
            },
            // 查询操作
            handleSearch (){

                this.query.pageNo = 1;
                this.getPage();
            },

            // 分页导航
            handlePageChange (val) {
                this.query.pageNo = val;
                this.getPage();
            },
            handleSizeChange(val) {
                this.query.pageNo = 1;
                this.query.pageSize = val;
                this.getPage();
            },

            handleShow(index,row){
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    id:row.id,
                }

                // 二次确认
                this.$confirm("确定恢复【"+row.ftitle+"】？"  , "提示", {
                    type: "warning",
                }) .then(() => {

                    admin_forum_showNormal(o).then((res) => {
                        dealResult(res.data);
                        if (res.data.status == 1  ) {
                            this.$message.success(res.data.msg)
                            this.getPage();
                            this.getTrashNum();
                        }  else {
                            this.$message.error(res.data.msg)
                        }

                    })

                });
            },



            //删除操作
            handleDelete(index,row){
                 this.delVisible=true;
                 this.delData =row ;
            },

            suredel(){
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:this.topbestData.type,
                    id:this.delData.id,
                    delMsg:this.delData.delMsg,
                }
                admin_forum_del(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.delVisible=false;
                        this.$message.success(res.data.msg);
                        this.getPage();
                        this.getTrashNum();
                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },

            //获取列表数据
            getPage(){
                this.query.uid=this.lander.uid;
                this.query.token=this.lander.token;
                admin_forum_page(this.query).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.tableData = res.data.obj.list
                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },
            //回收站数量
            getTrashNum(){
                let o={  uid:this.lander.uid, token:this.lander.token}
                admin_forum_getTrashNum(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.trashNum = res.data.obj;
                    }  else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //获取分类列表数据
            getTypeList(){
                let o={  uid:this.lander.uid, token:this.lander.token}
                if(this.lander.role=='100'){
                    admin_type_getlist(o).then((res) => {
                        dealResult(res.data);
                        if (res.data.status == 1  ) {
                            this.typelist = res.data.obj;
                        }  else {
                            this.$message.error(res.data.msg)
                        }
                    });
                    return;
                }
                getTypeForumList(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                         this.typelist = res.data.obj;
                    }  else {
                        this.$message.error(res.data.msg)
                    }
                });

            },
            //获取调研组员的分类
            getManageTyeLi() {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    manageUid: this.lander.uid
                }
                admin_users_type_seeTypes(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        let li=res.data.obj;
                        this.typelist=[];
                        for(let i=0;i<li.length;i++){
                            let forumobj={id:li[i].typeId,name:li[i].name};
                            this.typelist.push(forumobj);
                        }


                    }

                })
            },

        },
        mounted() {
            this.lander = JSON.parse(this.$store.state.logininfo);
            //去后端查询所有的用户给tableData赋值
            this.getPage();
            if( this.lander.role=='100'){
                this.getTypeList();
                this.getTrashNum();
            }
            if( this.lander.role=='50'){
                this.getManageTyeLi() ;
            }

        }
    }
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .table {
        width: 100%;
        font-size: 14px;
    }
    .red {
        color: #ff0000;
    }
    .mr10 {
        margin-right: 10px;
        width: 150px;
    }
    /*滚动条的宽度*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 10px;
    }
    /*滚动条滑块*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background-color: #409eff;
        /*border-radius: 3px;*/
    }
</style>
